module.exports = __webpack_public_path__ + "media/images/flags/1x1/bra-d0204220208face8dbd1fc277892ac2d.svg";